// extracted by mini-css-extract-plugin
export var backupIcon = "_si-1";
export var image = "_si-0";